// extracted by mini-css-extract-plugin
module.exports = {"footerLink":"Footer-FooterLink-module--footer-link--3Dj4k"};